export default "__VITE_ASSET__3ca16731__"